export default __webpack_public_path__ + "static/media/check_circle_green.c3458d2d.svg";